<template>
	<div class="finance">
		<div class="group-content">
			<van-notice-bar scrollable v-if="getTotalStr!=''" :text="getTotalStr" />
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
			<van-list
			v-model="loading"
			:finished="finished"
			:finished-text="financeList.length==0?'暂无数据':'没有更多数据了'"
			@load="getFinanceData"
			>
			<van-swipe-cell
				v-for="(item,ind) in financeList"
				:key="ind">

				<van-card
					:desc="item.remark?('备注：'+item.remark):''"
					:tag="types==3?'':(item.in_settle==1?'已入结算':'未入结算')"
					:price="$options.filters['number_format'](item.amount,2)"
					:style="'margin-bottom:10px;'"
				>
					<template #title>
						经手人：{{item.user}}
					</template>
					<template #num v-if="types==3">
						<van-tag plain type="warning">{{item.times_apply?'已报账':'未报账'}}</van-tag>
					</template>
					<template #num v-else>
						{{item.times_add}}
					</template>
					<template #thumb v-if="item.bill">
						<img :src="item.bill.indexOf('http')==-1?(attach_url+item.bill):item.bill" style="width:100%; height:100%;" @click="previewImg(item.bill)"/>
					</template>
				</van-card>

				<template #right v-if="settled==0">
					<van-button square text="编辑" type="primary" @click="onEditFinance(item.id, ind)"/>
					<van-button square text="报账" type="primary" @click="onEditApplyFinance(item.id, ind)" v-if="types==3&&!item.times_apply"/>
					<van-button square text="删除" type="danger" @click="onDelFinance(item.id)"/>
				</template>

			</van-swipe-cell>
			</van-list>
		</van-pull-refresh>

			<div class="empty" v-if="financeList.length==0">
				<span class="msg">没有相关信息！</span>
			</div>
		</div>

		<van-popup v-model="showEditFinance" round position="bottom" :style="{ 'max-height': '80%', 'bottom':'50px', 'padding-top':'20px'}">
			<van-cell-group > 
				<van-cell
					title="预支金额"
					:value="financeInfo.amount"
					title-class="van-cell-title"
					v-if="applyFinance"
				>
				</van-cell>
				<van-field
					v-model.trim="financeInfo.amount"
					:label="types==3?'预支金额：':'金额：'"
					placeholder="请输入金额"
					clearable
					required
					v-else
				></van-field>
				<van-field
					v-model.trim="financeInfo.amount_apply"
					label="报账金额："
					placeholder="请输入金额"
					clearable
					required
					v-if="types==3&&applyFinance"
				></van-field>
				<van-field
					v-model.trim="financeInfo.user"
					label="经手人："
					placeholder="请输入经手人"
					clearable
				></van-field>
				<van-cell
					:value="''"
					title-class="van-cell-title"
					v-if="types!=3||(types==3&&applyFinance)"
				>
					<template #title>
						<span class="custom-title">加入结算：{{inSettleChk?'是':'否'}}</span>
					</template>
					<template #right-icon>
						<van-switch v-model="inSettleChk"  @input="onInSettleChk"/>
					</template>
				</van-cell>
				<van-cell
					title="清单："
					:value="''"
					title-class="van-cell-title"
					v-if="types!=3||(types==3&&applyFinance)"
				>
					<template #right-icon>
						<van-uploader ref="clansFinanceUploader" max-count="1" v-model="imgList" :max-size="imgSizeLimit" @oversize="onOversize" :after-read="afterReadImg" :before-read="beforeRead"/>
					</template>
				</van-cell>

				<van-field
				  v-model.trim="financeInfo.remark"
				  rows="3"
				  autosize
				  label="备注："
				  type="textarea"
				  maxlength="1000"
				  placeholder="请输入备注内容"
				  show-word-limit
				/>
			</van-cell-group>
			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="1"></van-col>
				<van-col span="9">
					<van-button type="default" block  @click="showEditFinance=false">取消</van-button>
				</van-col>
				<van-col span="1"></van-col>
				<van-col span="12">
					<van-button type="primary" block  @click="onSaveFinance">保存</van-button>
				</van-col>
				<van-col span="1"></van-col>
			</van-row> 

		</van-popup>


		<van-button square text="新增" type="default" class="btn_add" @click="onAddFinance" v-if="settled==0"/>


	</div>
</template>

<script>
import {List, Card, SwipeCell, DatetimePicker,ImagePreview } from "vant";
import { chkImgType } from "@/utils/common.js";

export default {
	name: "clans_finance",
	components: {
		"van-list": List,
		"van-card":Card,
		"van-swipe-cell":SwipeCell,
		"van-datetime-picker":DatetimePicker
	},
	props:{
		fid:Number,
		types:String,
		settled:Number
	},
	data() {
		return {
			title: "账务明细管理",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url:this.Conf.serverPre,

			financeList:[],
			showEditFinance:false,
			financeInfo:{},
			
			imgList:[],
			imgSizeLimit:500 * 1024,
			saveFlag:false,
			inSettleChk:false,

			applyFinance:false,

			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false
		};
	},
	created() {
		this.getStateConfigs();
		this.getFinanceData();
		
	},
	computed: {
		filterBillImg(){
			return function(bill){
				if(bill){
					return bill.indexOf('http')==-1?(this.attach_url+bill):bill;
				}
				return '';
			}
		},
		getTotalStr:function(){
			let totalAll = 0,totalSettle=0;
			for(var i=0,il=this.financeList.length; i<il; i++){
				totalAll += this.financeList[i].amount;
				if(this.financeList[i].in_settle == 1){
					totalSettle += this.financeList[i].amount;
				}
			}
			let str = '';
			let totalAllStr = this.$options.filters['number_format'](totalAll,2);
			let totalSettleStr = this.$options.filters['number_format'](totalSettle,2);
			if(totalAll > 0){
				str = '合计：'+totalAllStr+'元；';
				if(totalAll>totalSettle){
					str += '已入结算：'+totalSettleStr+'元；';
					str += '未入结算：'+this.$options.filters['number_format'](totalAll-totalSettle,2)+'元；';
				}
			}
			return str;
		}
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		beforeRead(file){
			return chkImgType(file);
		},
		onOversize(){
			this.$toast.fail("图片大小不能超过 500kb");
		},
		afterReadImg(file){
			this.financeInfo['new_bill'] = file.content
			this.imgList = [{url:file.content, isImage: true}];
		},
		getFinanceData(){
			if (this.finished) {
				return false;
			}
			this.loading = true;
			setTimeout(() => {
				if (this.refreshing) {
					this.financeList = [];
					this.refreshing = false;
				}
				this.page = this.page+1;
				var params = {
					u_id:this.u_id,
					token:this.token,
					fid:this.fid,
					types:this.types
				};
				params.page = this.page;

				let that = this;
				var url = this.Conf.serverUrl + "clans/financeDetail" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.loading = false;
					if(response.data.code == 40001){
						this.$toast.fail(response.data.msg);
					}else{
						if (response.data.page == 1) {
							this.pageSize = response.data.pageSize;
							this.total = response.data.total;
							this.financeList = response.data.datas;
						}else{
							this.financeList = this.financeList.concat(response.data.datas);
						}
						if(this.page*this.pageSize >= this.total){
							this.finished = true;
						}
					}
				})
				.catch(error => {});

			}, 1000);
		},
		onRefresh(cur) {
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.getFinanceData();
		},
		onAddFinance(){
			this.financeInfo = {f_id:this.fid, types:this.types,in_settle:0};
			this.inSettleChk = false;
			this.showEditFinance = true;
		},
		onEditFinance(id, ind){
			this.financeInfo = this.financeList[ind];
			this.inSettleChk = this.financeInfo.in_settle==1;
			this.imgList = [];
			if(this.financeInfo.bill){			
				this.imgList = [{url:this.financeInfo.bill.indexOf('http')==-1?(this.attach_url+this.financeInfo.bill):this.financeInfo.bill, isImage: true}];
			}
			this.showEditFinance = true;
		},
		onEditApplyFinance(id,ind){
			this.applyFinance = true;
			this.onEditFinance(id,ind);
		},
		onDelFinance(id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "删除后将不可恢复，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/financeDetailDel" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.onRefresh(true);
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		onSaveFinance(){
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			if(!this.applyFinance && !this.financeInfo['amount']){
				this.$toast.fail("请输入"+(types==3?'预支':'')+"金额！");
				return false;
			}
			if(this.applyFinance && !this.financeInfo['amount_apply']){
				this.$toast.fail("请输入报账金额！");
				return false;
			}
			this.saveFlag = true;

			if(this.imgList.length > 0 && this.imgList[0].content){
				this.financeInfo['new_bill'] = this.imgList[0].content;
			}

			var params = {
				u_id:this.u_id,
				token:this.token,
				data:this.financeInfo,
				apply:this.applyFinance?1:0
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/financeDetailSave" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.saveFlag = false;
				that.showEditFinance = false;
				that.$toast.success(response.data.msg);
				if(response.data.code == 200){
					that.onRefresh();
				}
			})
			.catch(error => {});
		},
		onInSettleChk(chk){
			this.financeInfo.inSettleChk = chk?1:0;
		},
		previewImg(img){
			var imgarr = [img.indexOf('http')==-1?(this.attach_url+img):img];
			ImagePreview({
				images: imgarr,
				showIndex:false,
				showIndicators:true
			});
		}
	},
	watch:{
		showEditFinance(){
			if(!this.showEditFinance){
				this.applyFinance = false;
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/FinanceDetail.vue